
(function(template){
    define('vue!app/views/vue/components/cartComponent/cartBody/guestItinerary',[
        "Vue",
        "helpers",
        "vuex",
        'vuecal',
        'vue!app/views/vue/basicComponents/popup'

    ], function (
        Vue,
        helpers,
        vuex,
        vuecal,
        popup
    ) {
        return {
            template: template,
            name: "",
            props: ['show_list_view', 'view_summary'],
            data: function () {
                return {
                    showAllDayEvents: false,
                    selectedEvent: {},
                }
            },
            computed: _.extend(
                vuex.mapState(['users', "selectedServices", "loggedInUser", 'activeStep', 'folioTotal', 'UserCalenderEvents', 'activeUser', 'desktopMode', 'currentlyEditingService', 'usersWithIds']), {

                    userList:function(){
                    var clonedList = _.extend({},this.usersWithIds)
                   if(this.loggedInUser) delete clonedList[app.data.DefaultCustomerId]
                    return clonedList
                }
                }),
            components: {
                "vue-cal": vuecal,
                popup: popup,
            },
            methods: {
                onChange: function (e) {
                    const options = event.target.options;
                    const selectedOption = options[options.selectedIndex];
                    helpers.updateCalender(e.target.value, selectedOption.textContent)
                },
                onEventClick: function (event, e) {

                    this.selectedEvent = event
                    this.$refs.package_item_conflict_popup.show()
                    // Prevent navigating to narrower view (default vue-cal behavior).
                    e.stopPropagation()
                },

            },
            watch:{
                  UserCalenderEvents:function(val){
                      var vm = this
                      vm.showAllDayEvents = false
                       _.each(val,function(booking){
                           if(booking.allDay) vm.showAllDayEvents = true
                       })
                    },
            },
        }
    })
})('<div> <popup ref="package_item_conflict_popup" :showBook="false"> <template v-slot:header> {{selectedEvent.title}} </template> <template v-slot:body> <p><label>{{localStrings.sideCart.calender.guestNameLabel}}: </label><strong>{{selectedEvent.CustomerName}}</strong></p> <p><label>{{localStrings.sideCart.calender.bookedForLabel}}: </label><strong>{{selectedEvent.formattedDateTime}}</strong></p> <!-- <p v-if="selectedEvent.LocationName"><label>Location: </label><strong>{{selectedEvent.LocationName}}</strong></p> --> <div v-for="(v,k,index) in localStrings.sideCart.calender.bookingDetailsLabel[selectedEvent.bookingType]" :key="index"> <p v-show="selectedEvent[v]"><label>{{k}}: </label><strong>{{selectedEvent[v]}}</strong></p> </div> <p v-if="selectedEvent.GuestRequest"><label>{{localStrings.sideCart.calender.guestRequest}}: </label><strong>{{selectedEvent.GuestRequest}}</strong></p> </template> </popup> <transition name="fade"> <div class="vue_cal_div" v-show="!view_summary &&desktopMode ||!desktopMode && !show_list_view"> <!-- <p class="user_weekly_schedule_text">{{username}}\'s Weekly Schedule</p> --> <select @change="onChange" class="user_weekly_schedule_text" name="" id=""> <option v-for="(v,k,i) in userList" :key="i" :value="k">{{v}}</option> </select> <vue-cal :events="UserCalenderEvents" small default-view="week" :disable-views="[\'years\',\'year\']" style="height: 600px;width:100%;margin-top:-10px" :time-from="9 * 60" :time-to="22 * 60" :time-step="30" :show-all-day-events="showAllDayEvents" :on-event-click="onEventClick"> <div slot="no-event"> <p class="clickable">{{localStrings.stepper.body.schedule.calendar.placeholder.noEventBooked}} </p> </div> <template v-slot:event-renderer="{ event, view, cell}"> <div class="vuecal__event-title vuecal_event_title_style" v-html="event.title"></div> <small class="vuecal__event-time"> <br /> <span v-if=\'event.bookingType == "diningBooking"\'><i class="fas fa-utensils"></i></span> <span v-else-if=\'event.bookingType == "golfBooking"\'><i class="fas fa-golf-ball"></i></span> <span v-else-if=\'event.bookingType == "pmsBooking"\'><i class="fas fa-hotel"></i></span> </small> </template> </vue-cal> </div> </transition> </div>');
